// extracted by css-extract-rspack-plugin
export default {"sizeFluid":"100%","bookingDateTimePicker":"booking-date-time-picker__bookingDateTimePicker___cifSr"};